import { Component, NgZone, Renderer2, ViewChild } from '@angular/core';
import { NgbCollapseModule, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { DashboardService } from '../../Model/Dashboard/dashboard.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import moment from 'moment';
import { CommonModule, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { NgChartsModule } from 'ng2-charts';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { ChartConfiguration } from 'chart.js';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { Router } from '@angular/router';
import { UserRightService } from '../../Model/UserRight/user-right.service';

@Component({
  selector: 'app-dashboard-front',
  standalone: true,
  imports: [CommonModule, NgChartsModule, DataTablesModule, FormsModule, NgbDatepickerModule, NgbDropdownModule, DecimalPipe, NgSelectModule, NgbCollapseModule, LoaderComponent, NgbTooltip],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './dashboard-front.component.html',
  styleUrl: './dashboard-front.component.scss'
})
export class DashboardFrontComponent {
  isDisabled: boolean = false;
  isApply: boolean = false;
  isGrouping: boolean = false;

  Dropdown1 = [] as any;
  Dropdown2 = [] as any;

  ShiftGroups = [] as any;
  Shifts = [] as any;
  Regions = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  IndustrySegments = [] as any;
  SiteOwners = [] as any;

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 25,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columns: []
  };

  dtOptionsbranchSummary: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 25,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columns: [
      {
        data: null,
        render: (data, type, row, meta) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true
      },
      { data: 'TotalManpower', className: "text-end" },
      { data: 'TotalPunch', className: "text-end" },
      { data: 'TotalPending', className: "text-end" },
      {
        data: 'TotalActive', className: "text-end",
        render: (data, type, row) => {
          const isVisible = this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled;
          return isVisible ? data : '';
        },
        createdCell: (td, cellData, rowData, rowIndex, colIndex) => {
          // Apply colHide class to the TD element based on visibility
          if (!this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled) {
            $(td).addClass('colHide');
          } else {
            $(td).removeClass('colHide');
          }
        }
      },
      { data: 'BranchName' },
      { data: 'SiteCount', className: "text-end" },
      { data: 'Punched', className: "text-end" },
      { data: 'Pending', className: "text-end" }
    ]
  };

  dtOptionsEmp: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 25,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columns: [
      {
        data: null,
        render: (data, type, row, meta) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true
      },
      {
        data: 'EmployeeName',
        render: (data: any, type: any, row: any) => {
          if (type === 'display') {
            // Create profile image or initial div
            let profileImage = '';
            if (row.EmpPhoto) {
              profileImage = `
              <img class="userImage" 
                   src="${this.common.PhotoLink(row.EmpPhoto)}" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-profile="true" />
            `;
            } else {
              profileImage = `
              <div class="initial-image" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-profile="true">
                <div class="image">${this.common.getInitial(row.EmployeeName)}</div>
              </div>
            `;
            }

            // Return the complete structure
            return `
            <div class="row no-gutters cursor-pointer" style="align-items: center; width: 300px;">
              <div class="col-2">
                ${profileImage}
              </div>
              <div class="col-9 userdetail">
                <span class="text-label">${row.EmployeeName || ''}</span><br />
                <span class="text-label-light">#${row.EmpCode || ''}</span><br />
                <span class="text-label-light">${row.DesignationName || ''}</span>
              </div>
            </div>
          `;
          }
          return data; // Return raw data for sorting/filtering
        }
      },
      {
        data: 'ShiftGroupName',
        render: (data, type, row) => {
          return `<span style="width: 100px;display:block">${data}</span>`;
        },
      },
      {
        data: 'ShiftTitle',
        render: (data, type, row) => {
          return `<span style="width: 100px;display:block">${data}</span>`;
        },
      },
      {
        data: 'AttendanceDate',
        render: (data: any, type: any) => {
          if (type === 'display' || type === 'filter') {
            return this.datepipe.transform(data, 'dd MMM, yyyy') || '';
          }
          return data;
        }
      },
      {
        data: 'AttendanceRemark',
        render: (data, type, row) => {
          const isOnlineAttendance = row.IsOnlineAttendance >= 1;
          return `
            <span>${data}</span>
            ${isOnlineAttendance ? ' (R)' : ''}
        `;
        },
      },
      {
        data: 'InTime',
        render: (data: any, type: any, row: any) => {
          if (type === 'display') {
            // Format the time
            const formattedTime = this.formatTime(data);

            // Create image or initial div
            let imageContent = '';
            if (row.DailyAttendancePhotoIn) {
              imageContent = `
              <img class="userImage" 
                   src="${this.common.PhotoLink(row.DailyAttendancePhotoIn, true)}" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-in-time="true" />
            `;
            } else {
              imageContent = `
              <div class="initial-image" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-in-time="true">
                <div class="image">${this.common.getInitial(row.EmployeeName)}</div>
              </div>
            `;
            }

            return `
            <div>
              <span style="display: block;">${formattedTime}</span>
              ${imageContent}
            </div>
          `;
          }
          return data; // Return raw data for sorting/filtering
        }
      },
      {
        data: 'OutTime',
        render: (data: any, type: any, row: any) => {
          if (type === 'display') {
            // Format the time
            const formattedTime = this.formatTime(data);

            // Create image or initial div
            let imageContent = '';
            if (row.DailyAttendancePhotoOut) {
              imageContent = `
              <img class="userImage" 
                   src="${this.common.PhotoLink(row.DailyAttendancePhotoOut, true)}" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-in-time="false" />
            `;
            } else {
              imageContent = `
              <div class="initial-image" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-in-time="false">
                <div class="image">${this.common.getInitial(row.EmployeeName)}</div>
              </div>
            `;
            }

            return `
            <div>
              <span style="display: block;">${formattedTime}</span>
              ${imageContent}
            </div>
          `;
          }
          return data; // Return raw data for sorting/filtering
        }
      },
      {
        data: 'StateName',
        render: (data, type, row) => {
          return `<span style="width: 200px;display:block">${data}</span>`;
        },
      },
      {
        data: 'BranchName',
        render: (data, type, row) => {
          return `<span style="width: 200px;display:block">${data}</span>`;
        },
      },
      {
        data: 'ClientName',
        render: (data, type, row) => {
          return `<span style="width: 300px;display:block">${data}</span>`;
        },
      },
      {
        data: 'SiteName',
        render: (data, type, row) => {
          return `<span style="width: 300px;display:block">${data}</span>`;
        },
      },
      {
        data: 'SiteSupervisorName',
        render: (data, type, row) => {
          return `<span style="width: 200px;display:block">${data}</span>`;
        },
      },
    ]
  };

  dtTrigger: Subject<any> = new Subject<any>();
  dtTriggerbranchSummary: Subject<any> = new Subject<any>();
  dtTriggerEmp: Subject<any> = new Subject<any>();

  filter = {
    MonthYear: null as any,
    FromDate: null as any,//'01 Feb 2024'
    ToDate: null as any,//'27 Feb 2024'
    ESS_ShiftGroupMasterId: null,
    ShiftMasterId: null,
    RegionMasterId: null,
    BranchMasterId: null,
    ClientMasterId: null,
    SiteMasterId: null,
    SiteSupervisorId: null,
    IndustrySegmentId: null,
    StateMasterId: null,
    UserId: null,
    Type: 'SiteWise'
  }

  dfilter = {
    MonthYear: null as any,
    FromDate: null as any,//'01 Feb 2024'
    ToDate: null as any,//'27 Feb 2024'
    ESS_ShiftGroupMasterId: null,
    ShiftMasterId: null,
    RegionMasterId: null as any,
    BranchMasterId: null as any,
    ClientMasterId: null as any,
    SiteMasterId: null as any,
    SiteSupervisorId: null,
    IndustrySegmentId: null,
    StateMasterId: null as any,
    UserId: null,
    Type: 'EmpWise'
  }

  mfilter = {
    TodayDate: null as any,
    filterType: 3,
    FromDate: null as any,
    ToDate: null as any,
    YesterdateDate: null as any,
    ShiftGroupMasterID: [] as any,
    ShiftMasterID: [] as any,
    RegionMasterID: [] as any,
    StateMasterID: [] as any,
    BranchMasterID: [] as any,
    ClientGroupMasterID: [] as any,
    SiteMasterID: [] as any,
    IndustrySegmentId: [] as any,
    SiteOwnerID: [] as any,
  }

  Card = {
    Total: 0,
    TotalActive: 0,
    Present: 0,
    PresentPer: 0 as any,
    Absent: 0,
    AbsentPer: 0 as any,
    OnlineAttendance: 0,
    OnlineAttendancePer: 0 as any,
    WO: 0,
    WOPer: 0 as any,
  }

  Collapsed = {
    BranchGraph: false,
    AttendanceGraph: false,
    AttendanceAnalytics: false,
    EmployeeDetails: false,
    SummaryDetails: false,
  }

  ChartLegend = {
    Attendance: true,
    Branch: true,
  }

  groupby = {
    State: true,
    Region: true,
    Branch: true,
    Client: true,
    Site: true,
    Department: true,
    Designation: true,
    Supervisor: true,

    Checkall: true,
  }

  public AttendanceChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: []
  };

  public BranchChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: []
    }],
  };

  analyticsDatasBackup = [] as any;
  analyticsDatas = [] as any;
  branchSummary = [] as any;
  empDatas = [] as any;
  excelData = [] as any;
  allowRedirectDevice = false;
  constructor(
    private dashboard: DashboardService,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    public datepipe: DatePipe,
    private session: SessionService,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private zone: NgZone,
    private modalService: NgbModal,
    private router: Router,
    private userright: UserRightService,
  ) {
    this.common.getPageRights();
    this.common.CompanyParameter();
  }

  ngOnInit() {
    this.filter.UserId = this.session.GetUserDetails().UserId;
    this.ESS_FillComboForAttendanceDashboard();
    this.SelectDate('RegistrationDate', null, null);
    this.AllowRedirectOnDeivce();
    this.common.CheckExpiry();
  }

  ngOnDestroy(): void {
    $('#summarydata').off('click.summaryHandlers');
    $('#summarydatatable').off('click.summaryHandlers');
    $('#empdatatable').off('click.employeeHandlers');
    $('#empdatatable').off('click.profileImage');

    // Destroy DataTables
    if ($.fn.dataTable.isDataTable('#summarydata')) {
      $('#summarydata').DataTable().destroy();
    }
    if ($.fn.dataTable.isDataTable('#summarydatatable')) {
      $('#summarydatatable').DataTable().destroy();
    }
    if ($.fn.dataTable.isDataTable('#empdatatable')) {
      $('#empdatatable').DataTable().destroy();
    }
    this.dtTrigger.unsubscribe();
    this.dtTriggerbranchSummary.unsubscribe();
    this.dtTriggerEmp.unsubscribe();
  }

  FetchData() {
    if (this.mfilter.filterType == 0 || this.mfilter.filterType == 3) {
      this.SelectDate('RegistrationDate', null, null);
    } else {
      this.AttendanceDashboardGetData();
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.mfilter.TodayDate = moment(response.Table[0].RegistrationDate);
          this.mfilter.YesterdateDate = moment(response.Table[0].RegistrationDate).add(-1, 'day');
          this.mfilter.FromDate = {
            "year": this.mfilter.TodayDate.year(),
            "month": this.mfilter.TodayDate.month() + 1,
            "day": this.mfilter.TodayDate.date()
          };
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.AttendanceDashboardGetData();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  AttendanceDashboardGetData() {
    if (this.mfilter.filterType != 2 || (this.mfilter.filterType == 2 && (moment(this.dateFormate.format(this.mfilter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.mfilter.FromDate), 'DD MMM YYYY'))))) {
      this.isDisabled = true;
      this.isApply = true;
      this.isGrouping = true;

      if (this.mfilter.filterType == 0) {
        this.mfilter.FromDate = {
          "year": this.mfilter.TodayDate.year(),
          "month": this.mfilter.TodayDate.month() + 1,
          "day": this.mfilter.TodayDate.date()
        };
        this.mfilter.ToDate = {
          "year": this.mfilter.TodayDate.year(),
          "month": this.mfilter.TodayDate.month() + 1,
          "day": this.mfilter.TodayDate.date()
        };
      } else if (this.mfilter.filterType == 3) {
        this.mfilter.FromDate = {
          "year": this.mfilter.YesterdateDate.year(),
          "month": this.mfilter.YesterdateDate.month() + 1,
          "day": this.mfilter.YesterdateDate.date()
        };
        this.mfilter.ToDate = {
          "year": this.mfilter.YesterdateDate.year(),
          "month": this.mfilter.YesterdateDate.month() + 1,
          "day": this.mfilter.YesterdateDate.date()
        };
      }

      if (this.mfilter.filterType == 1) {
        this.filter.MonthYear = this.dateFormate.fullmonth[this.mfilter.FromDate.month - 1] + ' ' + this.mfilter.FromDate.year;
        this.filter.FromDate = null;
        this.filter.ToDate = null;
      } else if (this.mfilter.filterType == 0 || this.mfilter.filterType == 2 || this.mfilter.filterType == 3) {
        this.filter.MonthYear = null;
        this.filter.FromDate = this.dateFormate.format(this.mfilter.FromDate);
        this.filter.ToDate = this.dateFormate.format(this.mfilter.ToDate);
      } else if (this.mfilter.filterType == 4) {
        this.filter.MonthYear = null;
        this.filter.FromDate = this.dateFormate.format(this.mfilter.ToDate);
        this.filter.ToDate = this.dateFormate.format(this.mfilter.ToDate);
      }

      if (this.mfilter.ShiftGroupMasterID.length > 0)
        this.filter.ESS_ShiftGroupMasterId = this.mfilter.ShiftGroupMasterID.toString();
      else
        this.filter.ESS_ShiftGroupMasterId = null;

      if (this.mfilter.ShiftMasterID.length > 0)
        this.filter.ShiftMasterId = this.mfilter.ShiftMasterID.toString();
      else
        this.filter.ShiftMasterId = null;

      if (this.mfilter.RegionMasterID.length > 0)
        this.filter.RegionMasterId = this.mfilter.RegionMasterID.toString();
      else
        this.filter.RegionMasterId = null;

      if (this.mfilter.StateMasterID.length > 0)
        this.filter.StateMasterId = this.mfilter.StateMasterID.toString();
      else
        this.filter.StateMasterId = null;

      if (this.mfilter.BranchMasterID.length > 0)
        this.filter.BranchMasterId = this.mfilter.BranchMasterID.toString();
      else
        this.filter.BranchMasterId = null;

      if (this.mfilter.ClientGroupMasterID.length > 0)
        this.filter.ClientMasterId = this.mfilter.ClientGroupMasterID.toString();
      else
        this.filter.ClientMasterId = null;

      if (this.mfilter.SiteMasterID.length > 0)
        this.filter.SiteMasterId = this.mfilter.SiteMasterID.toString();
      else
        this.filter.SiteMasterId = null;

      if (this.mfilter.IndustrySegmentId.length > 0)
        this.filter.IndustrySegmentId = this.mfilter.IndustrySegmentId.toString();
      else
        this.filter.IndustrySegmentId = null;

      if (this.mfilter.SiteOwnerID.length > 0)
        this.filter.SiteSupervisorId = this.mfilter.SiteOwnerID.toString();
      else
        this.filter.SiteSupervisorId = null;

      try {
        this.dashboard.ESS_AttendanceDashboardGetDataRevised(this.filter).subscribe({
          next: (response) => {
            try {
              if (response.Table) {
                this.Card.Total = response.Table[0].TotalBillable;
                this.Card.TotalActive = response.Table[0].TotalActive;
                this.Card.Present = response.Table[0].Present;
                this.Card.PresentPer = ((this.Card.Present * 100) / this.Card.Total).toFixed(2);
                this.Card.Absent = response.Table[0].Absent;
                this.Card.AbsentPer = ((this.Card.Absent * 100) / this.Card.Total).toFixed(2);
                this.Card.OnlineAttendance = response.Table[0].ManualAttendance;
                this.Card.OnlineAttendancePer = ((this.Card.OnlineAttendance * 100) / this.Card.Total).toFixed(2);
                this.Card.WO = response.Table[0].WeekOff;
                this.Card.WOPer = ((this.Card.WO * 100) / this.Card.Total).toFixed(2);
              }

              if (response.Table4) {
                this.AttendanceChartData.labels = response.Table4.map((e: any) => e.AttendanceDate);
                this.AttendanceChartData = {
                  labels: response.Table4.map((e: any) => e.AttendanceDate),
                  datasets: [{
                    label: 'Present',
                    data: response.Table4.map((e: any) => e.Present),
                    borderColor: ['#4ce2b0'],
                    backgroundColor: ['#4ce2b0'],
                  },
                  {
                    label: 'Absent',
                    data: response.Table4.map((e: any) => e.Absent),
                    borderColor: ['#ff4c4c'],
                    backgroundColor: ['#ff4c4c'],
                  },
                  {
                    label: 'Weekoff',
                    data: response.Table4.map((e: any) => e.WeekOff),
                    borderColor: ['#6A0DAD'],
                    backgroundColor: ['#6A0DAD'],
                  }
                  ],
                };
              }

              if (response.Table1) {
                this.BranchChartData.labels = response.Table1.map((e: any) => e.BranchName);
                this.BranchChartData = {
                  labels: response.Table1.map((e: any) => e.BranchName),
                  datasets: [{
                    label: 'Present',
                    data: response.Table1.map((e: any) => e.Present),
                    borderColor: ['#4ce2b0'],
                    backgroundColor: ['#4ce2b0'],
                  },
                  {
                    label: 'Absent',
                    data: response.Table1.map((e: any) => e.Absent),
                    borderColor: ['#ff4c4c'],
                    backgroundColor: ['#ff4c4c'],
                  },
                  {
                    label: 'Weekoff',
                    data: response.Table1.map((e: any) => e.WeekOff),
                    borderColor: ['#6A0DAD'],
                    backgroundColor: ['#6A0DAD'],
                  }
                  ],
                };
              }

              if (response.Table3) {
                this.analyticsDatasBackup = response.Table3.length > 0 ? response.Table3 : [];
                this.analyticsDatas = Object.values(response.Table3.length > 0 ? response.Table3 : []);
                this.showGroup();
                this.initializeDataTable('#summarydata', this.analyticsDatas);
              }

              if (response.Table2) {
                this.branchSummary = Object.values(response.Table2.length > 0 ? response.Table2 : []);
                this.initializeDataTable('#summarydatatable', this.branchSummary);
              }

              this.isDisabled = false;
              this.isGrouping = false;
              this.isApply = false;
            } catch (e) {
              this.isDisabled = false;
              this.isGrouping = false;
              this.isApply = false;
            }
          },
          complete: () => {
            this.isDisabled = false;
          },
          error: (error) => {
            console.log(error);
            this.isDisabled = false;
            this.isGrouping = false;
            this.isApply = false;
          },
        });
      } catch (e) {
        this.isDisabled = false;
        this.isGrouping = false;
        this.isApply = false;
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  async AttendanceDashboardGetDataDetail(Type: String, id: number) {
    try {
      this.isDisabled = true;
      this.isApply = true;
      this.isGrouping = true;
      await new Promise(f => setTimeout(f, 500));
      this.dfilter = {
        MonthYear: null as any,
        FromDate: null as any,//'01 Feb 2024'
        ToDate: null as any,//'27 Feb 2024'
        ESS_ShiftGroupMasterId: null,
        ShiftMasterId: null,
        RegionMasterId: null,
        BranchMasterId: null,
        ClientMasterId: null,
        SiteMasterId: null,
        SiteSupervisorId: null,
        IndustrySegmentId: null,
        StateMasterId: null,
        UserId: null,
        Type: 'EmpWise'
      }

      this.dfilter.MonthYear = this.filter.MonthYear;
      this.dfilter.FromDate = this.filter.FromDate;
      this.dfilter.ToDate = this.filter.ToDate;

      if (Type == 'State') {
        this.dfilter.StateMasterId = id;
      } else if (Type == 'Region') {
        this.dfilter.RegionMasterId = id;
      } else if (Type == 'Branch') {
        this.dfilter.BranchMasterId = id;
      } else if (Type == 'Client') {
        this.dfilter.ClientMasterId = id;
      } else if (Type == 'Site') {
        this.dfilter.SiteMasterId = id;
      }
      this.dashboard.ESS_AttendanceDashboardGetDataRevised(this.dfilter).subscribe({
        next: (response) => {
          try {
            if (response.Table) {
              this.empDatas = Object.values(response.Table.length > 0 ? response.Table : []);
              this.Collapsed.EmployeeDetails = true;
            } else {
              this.empDatas = [];
              this.toast.show({ message: 'Data not found', type: toastTypeEnum.warning });
            }
            this.initializeDataTable('#empdatatable', this.empDatas);

            this.isDisabled = false;
            this.isGrouping = false;
            this.isApply = false;
          } catch (e) {
            this.isDisabled = false;
            this.isGrouping = false;
            this.isApply = false;
          }
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          console.log(error);
          this.isDisabled = false;
          this.isGrouping = false;
          this.isApply = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
      this.isGrouping = false;
      this.isApply = false;
    }
  }

  onSwitchChange(event: any, cardname: string) {
    if (cardname == "AttendanceGraph") {
      this.Collapsed.AttendanceGraph = event.target.checked;
    } else if (cardname == "BranchGraph") {
      this.Collapsed.BranchGraph = event.target.checked;
    } else if (cardname == "AttendanceAnalytics") {
      this.Collapsed.AttendanceAnalytics = event.target.checked;
    } else if (cardname == "SummaryDetails") {
      this.Collapsed.SummaryDetails = event.target.checked;
    }
  }

  ExcelDump(id: number) {
    this.isDisabled = true;
    this.excelData = [];
    if (id == 0) {
      this.excelData = JSON.parse(JSON.stringify(this.groupby.Site ? this.analyticsDatasBackup : this.analyticsDatas));

      this.excelData.forEach(function (x: any) { delete x.BranchId, delete x.ClientId, delete x.RegionMasterID, delete x.SiteId, delete x.SiteSupervisorId, delete x.StateId });
      if (!this.groupby.State) {
        this.excelData.forEach(function (x: any) { delete x.StateName });
      } if (!this.groupby.Region) {
        this.excelData.forEach(function (x: any) { delete x.RegionName });
      } if (!this.groupby.Branch) {
        this.excelData.forEach(function (x: any) { delete x.BranchName });
      } if (!this.groupby.Client) {
        this.excelData.forEach(function (x: any) { delete x.ClientName });
      } if (!this.groupby.Site) {
        this.excelData.forEach(function (x: any) { delete x.SiteCode, delete x.SiteName });
      } if (!this.groupby.Department) {
        this.excelData.forEach(function (x: any) { delete x.DepartmentName });
      } if (!this.groupby.Designation) {
        this.excelData.forEach(function (x: any) { delete x.DesignationName });
      } if (!this.groupby.Site) {
        this.excelData.forEach(function (x: any) { delete x.SiteSupervisorName });
        this.excelData.forEach(function (x: any) { delete x.SiteStartDate });
        this.excelData.forEach(function (x: any) { delete x.SiteEndDate });
      }
    } else if (id == 1) {
      this.excelData = JSON.parse(JSON.stringify(this.empDatas));
      this.excelData.forEach(function (x: any) {
        delete x.ClientId, delete x.DailyAttendanceInOutId, delete x.DailyAttendancePhotoIn, delete x.DailyAttendancePhotoOut, delete x.DepartmentId, delete x.DesignationId
          , delete x.ESS_ShiftGroupMasterId, delete x.EmpMasterId, delete x.EmpPhoto, delete x.IndustrySegmentId, delete x.IsInAttendanceMatch
          , delete x.IsOnlineAttendance, delete x.IsOutAttendanceMatch, delete x.Latitude, delete x.LatitudeOut, delete x.Longitude
          , delete x.LongitudeOut, delete x.OutAttendanceMatchPercentage, delete x.RegionMasterID, delete x.ShiftId, delete x.SiteId
          , delete x.SiteSupervisorId, delete x.StateId, delete x.ZoneId
          , delete x.BranchId, delete x.CheckInAddress, delete x.CheckOutAddress
          , delete x.AttendanceMatchPercentage, delete x.Altitude, delete x.AltitudeOut
      });
    } else if (id == 2) {
      this.excelData = JSON.parse(JSON.stringify(this.branchSummary));
      this.excelData.forEach(function (x: any) { delete x.BranchId });
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelData);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'ExcelSheet.xlsx');
    this.isDisabled = false;
  }

  async showGroup() {
    this.isGrouping = true;
    await new Promise(f => setTimeout(f, 500));
    try {
      this.analyticsDatas = [];
      var uniqueStateIds = []

      if (this.groupby.Site) {
        //this.analyticsDatas = this.analyticsDatasBackup;
        uniqueStateIds = this.analyticsDatasBackup.map((item: any) => item.SiteId).filter((value: any, index: any, self: any) => self.indexOf(value) === index);
      } else if (this.groupby.Client) {
        uniqueStateIds = this.analyticsDatasBackup.map((item: any) => item.ClientId).filter((value: any, index: any, self: any) => self.indexOf(value) === index);
      } else if (this.groupby.Branch) {
        uniqueStateIds = this.analyticsDatasBackup.map((item: any) => item.BranchId).filter((value: any, index: any, self: any) => self.indexOf(value) === index);
      } else if (this.groupby.Region) {
        uniqueStateIds = this.analyticsDatasBackup.map((item: any) => item.RegionMasterID).filter((value: any, index: any, self: any) => self.indexOf(value) === index);
      } else if (this.groupby.State) {
        uniqueStateIds = this.analyticsDatasBackup.map((item: any) => item.StateId).filter((value: any, index: any, self: any) => self.indexOf(value) === index);
      }

      if (uniqueStateIds.length > 0) {
        uniqueStateIds.forEach((element: any) => {
          var data = [];
          if (this.groupby.Site) {
            data = this.analyticsDatasBackup.filter((e: any) => e.SiteId == element);
            this.analyticsDatas.push(
              {
                "StateId": data[0].StateId,
                "StateName": data[0].StateName,
                "RegionMasterID": data[0].RegionMasterID,
                "RegionName": data[0].RegionName,
                "BranchId": data[0].BranchId,
                "BranchName": data[0].BranchName,
                "ClientId": element,
                "ClientName": data[0].ClientName,
                "SiteId": data[0].SiteId,
                "SiteName": data[0].SiteName,
                "DeviceInfo": data[0].DeviceInfo,
                "SiteSupervisorId": data[0].SiteSupervisorId,
                "SiteSupervisorName": data[0].SiteSupervisorName,
                "SiteManpower": data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0),
                "Present": data.reduce((accumulator: any, item: any) => accumulator + item.Present, 0),
                "WeekOff": data.reduce((accumulator: any, item: any) => accumulator + item.WeekOff, 0),
                "Absent": data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0),
                "Absent%": (data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0) * 100) / data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0)
              },
            );
          } else if (this.groupby.Client) {
            data = this.analyticsDatasBackup.filter((e: any) => e.ClientId == element);
            this.analyticsDatas.push(
              {
                "StateId": data[0].StateId,
                "StateName": data[0].StateName,
                "RegionMasterID": data[0].RegionMasterID,
                "RegionName": data[0].RegionName,
                "BranchId": data[0].BranchId,
                "BranchName": data[0].BranchName,
                "ClientId": element,
                "ClientName": data[0].ClientName,
                "SiteId": 0,
                "SiteName": "",
                "DeviceInfo": "",
                "SiteSupervisorId": 0,
                "SiteSupervisorName": "",
                "SiteManpower": data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0),
                "Present": data.reduce((accumulator: any, item: any) => accumulator + item.Present, 0),
                "WeekOff": data.reduce((accumulator: any, item: any) => accumulator + item.WeekOff, 0),
                "Absent": data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0),
                "Absent%": (data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0) * 100) / data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0)
              },
            );
          } else if (this.groupby.Branch) {
            data = this.analyticsDatasBackup.filter((e: any) => e.BranchId == element);
            this.analyticsDatas.push(
              {
                "StateId": data[0].StateId,
                "StateName": data[0].StateName,
                "RegionMasterID": data[0].RegionMasterID,
                "RegionName": data[0].RegionName,
                "BranchId": element,
                "BranchName": data[0].BranchName,
                "ClientId": 0,
                "ClientName": "",
                "SiteId": 0,
                "SiteName": "",
                "DeviceInfo": "",
                "SiteSupervisorId": 0,
                "SiteSupervisorName": "",
                "SiteManpower": data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0),
                "Present": data.reduce((accumulator: any, item: any) => accumulator + item.Present, 0),
                "WeekOff": data.reduce((accumulator: any, item: any) => accumulator + item.WeekOff, 0),
                "Absent": data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0),
                "Absent%": (data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0) * 100) / data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0)
              },
            );
          } else if (this.groupby.Region) {
            data = this.analyticsDatasBackup.filter((e: any) => e.RegionMasterID == element);
            this.analyticsDatas.push(
              {
                "StateId": data[0].StateId,
                "StateName": data[0].StateName,
                "RegionMasterID": 0,
                "RegionName": data[0].RegionName,
                "BranchId": 0,
                "BranchName": "",
                "ClientId": 0,
                "ClientName": "",
                "SiteId": 0,
                "SiteName": "",
                "DeviceInfo": "",
                "SiteSupervisorId": 0,
                "SiteSupervisorName": "",
                "SiteManpower": data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0),
                "Present": data.reduce((accumulator: any, item: any) => accumulator + item.Present, 0),
                "WeekOff": data.reduce((accumulator: any, item: any) => accumulator + item.WeekOff, 0),
                "Absent": data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0),
                "Absent%": (data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0) * 100) / data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0)
              },
            );
          } else if (this.groupby.State) {
            data = this.analyticsDatasBackup.filter((e: any) => e.StateId == element);
            this.analyticsDatas.push(
              {
                "StateId": element,
                "StateName": data[0].StateName,
                "RegionMasterID": 0,
                "RegionName": "",
                "BranchId": 0,
                "BranchName": "0",
                "ClientId": 0,
                "ClientName": "",
                "SiteId": 0,
                "SiteName": "",
                "DeviceInfo": "",
                "SiteSupervisorId": 0,
                "SiteSupervisorName": "",
                "SiteManpower": data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0),
                "Present": data.reduce((accumulator: any, item: any) => accumulator + item.Present, 0),
                "WeekOff": data.reduce((accumulator: any, item: any) => accumulator + item.WeekOff, 0),
                "Absent": data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0),
                "Absent%": (data.reduce((accumulator: any, item: any) => accumulator + item.Absent, 0) * 100) / data.reduce((accumulator: any, item: any) => accumulator + item.SiteManpower, 0)
              },
            );
          }
        });
      }

      this.initializeDataTable('#summarydata', this.analyticsDatas);
      this.isGrouping = false;
    } catch (e) {
      this.isDisabled = false;
      this.isGrouping = false;
    }
  }

  CheckAllGroupBy() {
    if (this.groupby.Checkall) {
      this.groupby.State = true;
      this.groupby.Region = true;
      this.groupby.Branch = true;
      this.groupby.Client = true;
      this.groupby.Site = true;
      this.groupby.Department = true;
      this.groupby.Designation = true;
      this.groupby.Supervisor = false;
    } else {
      this.groupby.State = false;
      this.groupby.Region = false;
      this.groupby.Branch = false;
      this.groupby.Client = false;
      this.groupby.Site = false;
      this.groupby.Department = false;
      this.groupby.Designation = false;
      this.groupby.Supervisor = false;
    }
  }

  onNavigate(event: any) {
    this.mfilter.FromDate = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  initializeDataTable(selector: string, data: any[]) {
    // Destroy existing DataTable and remove all event listeners
    const tableElement = $(selector);

    // Check if table exists
    if (tableElement.length === 0) {
      console.error(`Table ${selector} not found`);
      return;
    }
    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().destroy();
      $(selector).off('click');

      console.log('Destroying existing DataTable');
      const dataTable = tableElement.DataTable();

      // Clear all DataTables events
      dataTable.clear().destroy();

      // Remove DataTables classes and styles
      tableElement.removeClass('dataTable');
      tableElement.find('tbody, tfoot').remove();
    }

    let options = {};
    let columns: any[] = [];
    if (selector === '#summarydata') {
      columns = this.getColumns();
      options = {
        ...this.dtOptions,
        columns: columns
      };
    } else if (selector === '#summarydatatable') {
      options = this.dtOptionsbranchSummary;
    } else if (selector === '#empdatatable') {
      options = this.dtOptionsEmp;
    }

    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().destroy();
      $(selector).off('click'); // Remove all click handlers
    }
    // Initialize DataTable
    const table = $(selector).DataTable({
      data: data,
      ...options
    });

    // Use event namespacing for proper handler management
    if (selector === '#empdatatable') {
      this.setupEmployeeTableClickHandlers(selector, table);
    } else {
      this.setupSummaryTableClickHandlers(selector, table);
    }
  }

  getColumns(): any[] {
    const columns: any[] = [];
    columns.push(
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true
      },
      { title: 'SiteManpower', data: 'SiteManpower', className: "text-end" },
      { title: 'Present', data: 'Present', className: "text-end" },
      { title: 'Weekoff', data: 'WeekOff', className: "text-end" },
      { title: 'Absent', data: 'Absent', className: "text-end" },
      { title: 'Absent%', data: 'Absent%', className: "text-end", render: (data: any) => `${isNaN(data) ? 0 : data.toFixed(2)}%` },
    );
    if (this.groupby.State) {
      columns.push(
        {
          title: 'State Name',
          data: 'StateName',
          render: (data: any, type: any, row: any) => {
            const isVisible = this.groupby.State;
            const Id = row.StateId;
            return `
            <span 
              class="text-primary cursor-pointer" 
              style="width: 150px; display: block;"
              data-action="state-click"
              data-state-id="${Id}">
              ${isVisible ? data : ''}
            </span>
          `;
          },
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
            // Apply colHide class to the TD element based on visibility
            if (!this.groupby.State) {
              $(td).addClass('colHide');
            } else {
              $(td).removeClass('colHide');
            }
          }
        },
      );
    }
    if (this.groupby.Region) {
      columns.push(
        {
          title: 'Region Name',
          data: 'RegionName',
          render: (data: any, type: any, row: any) => {
            const isVisible = this.groupby.Region;
            const Id = row.RegionMasterID;
            return `
            <span 
              class="text-primary cursor-pointer" 
              style="width: 150px; display: block;"
              data-action="region-click"
              data-region-id="${Id}">
              ${isVisible ? data : ''}
            </span>
          `;
          },
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
            // Apply colHide class to the TD element based on visibility
            if (!this.groupby.Region) {
              $(td).addClass('colHide');
            } else {
              $(td).removeClass('colHide');
            }
          }
        },
      );
    }
    if (this.groupby.Branch) {
      columns.push(
        {
          title: 'Branch Name',
          data: 'BranchName',
          render: (data: any, type: any, row: any) => {
            const isVisible = this.groupby.Branch;
            const Id = row.BranchId;
            return `
            <span 
              class="text-primary cursor-pointer" 
              style="width: 150px; display: block;"
              data-action="branch-click"
              data-branch-id="${Id}">
              ${isVisible ? data : ''}
            </span>
          `;
          },
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
            // Apply colHide class to the TD element based on visibility
            if (!this.groupby.Branch) {
              $(td).addClass('colHide');
            } else {
              $(td).removeClass('colHide');
            }
          }
        },
      );
    }
    if (this.groupby.Client) {
      columns.push(
        {
          title: 'Client Name',
          data: 'ClientName',
          render: (data: any, type: any, row: any) => {
            const isVisible = this.groupby.Client;
            const Id = row.ClientId;
            return `
            <span 
              class="text-primary cursor-pointer" 
              style="width: 300px; display: block;"
              data-action="client-click"
              data-client-id="${Id}">
              ${isVisible ? data : ''}
            </span>
          `;
          },
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
            // Apply colHide class to the TD element based on visibility
            if (!this.groupby.Client) {
              $(td).addClass('colHide');
            } else {
              $(td).removeClass('colHide');
            }
          }
        },
      );
    }
    if (this.groupby.Site) {
      columns.push(
        {
          title: 'Site Name',
          data: 'SiteName',
          render: (data: any, type: any, row: any) => {
            const isVisible = this.groupby.Site;
            const Id = row.SiteId;

            return `
          <div class="site-device-container" style="width: 300px;">
            <div>
              <span 
                class="text-primary cursor-pointer" 
                data-action="site-click"
                data-site-id="${Id}">
                ${isVisible ? data : ''}
              </span>
            </div>
          </div>
        `;
          },
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
            // Apply colHide class to the TD element based on visibility
            if (!this.groupby.Site) {
              $(td).addClass('colHide');
            } else {
              $(td).removeClass('colHide');
            }
          }
        },
      );
    }
    if (this.groupby.Site && this.common.CompanyParameterValue.IsDeviceAttendanceApplicable) {
      columns.push(
        {
          title: 'Device Info',
          data: 'DeviceInfo',
          render: (data: any, type: any, row: any) => {
            const deviceHtml = this.formatDeviceInfo(row.DeviceInfo);

            return `
          <div class="site-device-container" style="width: 110px;">
            ${deviceHtml}
          </div>
        `;
          },
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
            // Apply colHide class to the TD element based on visibility
            if (!this.groupby.Site) {
              $(td).addClass('colHide');
            } else {
              $(td).removeClass('colHide');
            }
          }
        },
      );
    }
    if (this.groupby.Site) {
      columns.push(
        {
          title: 'Supervisor Name',
          data: 'SiteSupervisorName',
          render: (data: any, type: any, row: any) => {
            const isVisible = this.groupby.Site;
            const Id = row.SiteId;
            return `
                    <span  
                        style="width: 200px;display: block;">
                        ${isVisible ? data : ''}
                    </span>
                `;
          },
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
            // Apply colHide class to the TD element based on visibility
            if (!this.groupby.Site) {
              $(td).addClass('colHide');
            } else {
              $(td).removeClass('colHide');
            }
          }
        }
      );
    }
    return columns;
  }

  private setupSummaryTableClickHandlers(selector: string, table: DataTables.Api) {
    // Remove existing handlers first
    $(selector).off('click.summaryHandlers');

    // Add new handlers with namespace
    if (this.groupby.State) {
      $(selector).on('click.summaryHandlers', '[data-action="state-click"]', (event: any) => {
        this.handleSummaryClick(event, table, 'State', 'state-id');
      });
    }

    if (this.groupby.Region) {
      $(selector).on('click.summaryHandlers', '[data-action="region-click"]', (event: any) => {
        this.handleSummaryClick(event, table, 'Region', 'region-id');
      });
    }

    if (this.groupby.Branch) {
      $(selector).on('click.summaryHandlers', '[data-action="branch-click"]', (event: any) => {
        this.handleSummaryClick(event, table, 'Branch', 'branch-id');
      });
    }

    if (this.groupby.Client) {
      $(selector).on('click.summaryHandlers', '[data-action="client-click"]', (event: any) => {
        this.handleSummaryClick(event, table, 'Client', 'client-id');
      });
    }

    if (this.groupby.Site) {
      $(selector).on('click.summaryHandlers', '[data-action="site-click"]', (event: any) => {
        this.handleSummaryClick(event, table, 'Site', 'site-id');
      });
    }

    if (this.groupby.Site) {
      $(selector).on('click.summaryHandlers', '[data-action="device-click"]', (event: any) => {
        if (event.currentTarget.getAttribute('data-device-serial') != null && event.currentTarget.getAttribute('data-device-serial') != '') {
          this.GotoDevice(event.currentTarget.getAttribute('data-device-serial'));
        }
      });
    }
  }

  private handleSummaryClick(event: JQuery.ClickEvent, table: DataTables.Api, type: string, idAttr: string) {
    event.stopImmediatePropagation();
    const target = $(event.currentTarget);
    const Id = target.data(idAttr);
    const rowData = table.row(target.closest('tr')).data();

    if (Id && rowData) {
      this.AttendanceDashboardGetDataDetail(type, Id);
    }
  }

  private setupEmployeeTableClickHandlers(selector: string, table: DataTables.Api) {
    // Remove existing handlers first
    $(selector).off('click.employeeHandlers');

    // Add new handlers with namespace
    $(selector).on('click.employeeHandlers', '.userImage, .initial-image', (event: any) => {
      this.handleEmployeeImageClick(event);
    });

    $(selector).off('click.profileImage').on('click.profileImage', '.userImage, .initial-image[data-is-profile="true"]', (event) => {
      event.stopImmediatePropagation();
      const target = $(event.currentTarget);
      const rowData = JSON.parse(target.attr('data-row') || '{}');

      this.zone.run(() => {
        this.common.FullImage('', {
          ProfileImage: this.common.PhotoLink(rowData.EmpPhoto),
          Name: rowData.EmployeeName,
          Code: rowData.EmpCode,
          Designation: rowData.DesignationName,
          ContactNo: rowData.ContactNo
        });
      });
    });
  }

  private handleEmployeeImageClick(event: JQuery.ClickEvent) {
    event.stopImmediatePropagation();
    const target = $(event.currentTarget);
    const rowData = JSON.parse(target.attr('data-row') || '{}');
    const isInTime = target.attr('data-is-in-time') === 'true';
    console.log(rowData);
    this.zone.run(() => {
      this.common.FullImage(
        this.common.PhotoLink(isInTime ? rowData.DailyAttendancePhotoIn : rowData.DailyAttendancePhotoOut, true),
        {
          ProfileImage: this.common.PhotoLink(rowData.EmpPhoto),
          Name: rowData.EmployeeName,
          Code: rowData.EmpCode,
          Designation: rowData.DesignationName,
          ContactNo: rowData.ContactNo,
          MTitle1: isInTime ? 'In Date' : 'Out Date',
          MTitle2: isInTime ? 'In Time' : 'Out Time',
          MData1: isInTime ? rowData.InTime : rowData.OutTime,
          MData2: isInTime ? rowData.InTime : rowData.OutTime,
          Address: isInTime ? rowData.CheckInAddress : rowData.CheckOutAddress,
          IsAttendanceMatch: isInTime ? rowData.IsInAttendanceMatch : rowData.IsOutAttendanceMatch,
          AttendanceMatchPercentage: isInTime ? rowData.AttendanceMatchPercentage : rowData.OutAttendanceMatchPercentage,
          Latitude: isInTime ? rowData.Latitude : rowData.LatitudeOut,
          Longitude: isInTime ? rowData.Longitude : rowData.LongitudeOut
        }
      );
    });
  }

  private formatTime(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }

  ESS_FillComboForAttendanceDashboard() {
    this.isDisabled = true;
    this.Dropdown1 = [];
    this.Dropdown2 = [];
    this.Regions = [];
    this.Branchs = [];
    this.Clients = [];
    this.Sites = [];
    this.IndustrySegments = [];
    this.SiteOwners = [];
    return this.dashboard.ESS_FillComboForAttendanceDashboard({ 'SelectType': "FC" }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Dropdown1 = response.Table;
          this.ShiftGroups = [...new Map(this.Dropdown1.map((e: any) => ({ ShiftGroupMasterID: e.ESS_ShiftGroupMasterID, ShiftGroupName: e.ShiftGroupName })).map((item: any) => [item.ShiftGroupMasterID, item])).values()];
          this.Shifts = [...new Map(this.Dropdown1.map((e: any) => ({ ShiftMasterID: e.ShiftMasterID, ShiftTitle: e.ShiftTitle })).map((item: any) => [item.ShiftMasterID, item])).values()];
        }
        if (response.Table1) {
          this.Dropdown2 = response.Table1;
          this.Regions = [...new Map(this.Dropdown2.map((e: any) => ({ RegionMasterID: e.RegionMasterID, RegionName: e.RegionName })).map((item: any) => [item.RegionMasterID, item])).values()];
          this.Branchs = [...new Map(this.Dropdown2.map((e: any) => ({ BranchMasterID: e.BranchMasterID, BranchName: e.BranchName })).map((item: any) => [item.BranchMasterID, item])).values()];
          this.Clients = [...new Map(this.Dropdown2.map((e: any) => ({ ClientGroupMasterID: e.ClientGroupMasterID, ClientGroupName: e.ClientGroupName })).map((item: any) => [item.ClientGroupMasterID, item])).values()];
          this.Sites = [...new Map(this.Dropdown2.map((e: any) => ({ SiteMasterID: e.SiteMasterID, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];
          this.IndustrySegments = [...new Map(this.Dropdown2.map((e: any) => ({ IndustrySegmentId: e.IndustrySegmentID, IndustrySegmentName: e.IndustrySegmentName })).map((item: any) => [item.IndustrySegmentId, item])).values()];
          this.SiteOwners = [...new Map(this.Dropdown2.map((e: any) => ({ SiteOwnerID: e.SiteSupervisorId, SiteOwnerName: e.SiteSupervisorName })).map((item: any) => [item.SiteOwnerID, item])).values()];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  DropdownChange(Key: String) {
    if (Key == 'ShiftGroup') {
      this.Shifts = [];
      this.mfilter.ShiftMasterID = [];
      this.Shifts = [...new Map(this.Dropdown1.filter((e: any) => (this.mfilter.ShiftGroupMasterID.length > 0) ? this.mfilter.ShiftGroupMasterID.includes(e.ESS_ShiftGroupMasterID) : e).map((e: any) => ({ ShiftMasterID: e.ShiftMasterID, ShiftTitle: e.ShiftTitle })).map((item: any) => [item.ShiftMasterID, item])).values()];
    }

    // if (Key == 'ShiftGroup' || Key == 'Shift') {
    //   this.Regions = [];
    //   this.mfilter.RegionMasterID = [];
    //   this.RegionsMap.forEach((regionData, regionMasterID) => {
    //     if ((this.mfilter.ShiftGroupMasterID.length == 0 || this.mfilter.ShiftGroupMasterID.filter((e: any) => regionData.ESS_ShiftGroupMasterId.includes(e)).length > 0) &&
    //       (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.filter((e: any) => regionData.ShiftId.includes(e)).length > 0)) {
    //       this.Regions.push({
    //         RegionMasterID: regionMasterID,
    //         RegionName: regionData.RegionName
    //       });
    //     }
    //   });
    // }

    if (Key == 'Region') {
      this.Branchs = [];
      this.mfilter.BranchMasterID = [];
      this.Branchs = [...new Map(this.Dropdown2.filter((e: any) => (this.mfilter.RegionMasterID.length > 0) ? this.mfilter.RegionMasterID.includes(e.RegionMasterID) : e).map((e: any) => ({ BranchMasterID: e.BranchMasterID, BranchName: e.BranchName })).map((item: any) => [item.BranchMasterID, item])).values()];
    }

    if (Key == 'Region' || Key == 'Branch') {
      this.Clients = [];
      this.mfilter.ClientGroupMasterID = [];
      this.Clients = [...new Map(
        this.Dropdown2
          .filter((e: any) => {
            const regionMatch = this.mfilter.RegionMasterID.length === 0 ||
              this.mfilter.RegionMasterID.includes(e.RegionMasterID);
            const branchMatch = this.mfilter.BranchMasterID.length === 0 ||
              this.mfilter.BranchMasterID.includes(e.BranchMasterID);
            return regionMatch && branchMatch;
          })
          .map((e: any) => ({
            ClientGroupMasterID: e.ClientGroupMasterID,
            ClientGroupName: e.ClientGroupName
          }))
          .map((item: any) => [item.ClientGroupMasterID, item])
      ).values()];
    }

    if (Key == 'Region' || Key == 'Branch' || Key == 'Client') {
      this.Sites = [];
      this.mfilter.SiteMasterID = [];
      this.Sites = [...new Map(this.Dropdown2
        .filter((e: any) => {
          const regionMatch = this.mfilter.RegionMasterID.length === 0 ||
            this.mfilter.RegionMasterID.includes(e.RegionMasterID);
          const branchMatch = this.mfilter.BranchMasterID.length === 0 ||
            this.mfilter.BranchMasterID.includes(e.BranchMasterID);
          const clientMatch = this.mfilter.ClientGroupMasterID.length === 0 ||
            this.mfilter.ClientGroupMasterID.includes(e.ClientGroupMasterID);
          return regionMatch && branchMatch && clientMatch;
        })
        .map((e: any) => ({ SiteMasterID: e.SiteMasterID, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];
    }

    if (Key == 'Region' || Key == 'Branch' || Key == 'Client' || Key == 'Site') {
      this.SiteOwners = [];
      this.IndustrySegments = [];

      this.mfilter.SiteOwnerID = [];
      this.mfilter.IndustrySegmentId = [];

      this.SiteOwners = [...new Map(this.Dropdown2
        .filter((e: any) => {
          const regionMatch = this.mfilter.RegionMasterID.length === 0 ||
            this.mfilter.RegionMasterID.includes(e.RegionMasterID);
          const branchMatch = this.mfilter.BranchMasterID.length === 0 ||
            this.mfilter.BranchMasterID.includes(e.BranchMasterID);
          const clientMatch = this.mfilter.ClientGroupMasterID.length === 0 ||
            this.mfilter.ClientGroupMasterID.includes(e.ClientGroupMasterID);
          const siteMatch = this.mfilter.SiteMasterID.length === 0 ||
            this.mfilter.SiteMasterID.includes(e.SiteMasterID);
          return regionMatch && branchMatch && clientMatch && siteMatch;
        })
        .map((e: any) => ({ SiteOwnerID: e.SiteSupervisorId, SiteOwnerName: e.SiteSupervisorName })).map((item: any) => [item.SiteOwnerID, item])).values()];

      this.IndustrySegments = [...new Map(this.Dropdown2
        .filter((e: any) => {
          const regionMatch = this.mfilter.RegionMasterID.length === 0 ||
            this.mfilter.RegionMasterID.includes(e.RegionMasterID);
          const branchMatch = this.mfilter.BranchMasterID.length === 0 ||
            this.mfilter.BranchMasterID.includes(e.BranchMasterID);
          const clientMatch = this.mfilter.ClientGroupMasterID.length === 0 ||
            this.mfilter.ClientGroupMasterID.includes(e.ClientGroupMasterID);
          const siteMatch = this.mfilter.SiteMasterID.length === 0 ||
            this.mfilter.SiteMasterID.includes(e.SiteMasterID);
          return regionMatch && branchMatch && clientMatch && siteMatch;
        })
        .map((e: any) => ({ IndustrySegmentId: e.IndustrySegmentID, IndustrySegmentName: e.IndustrySegmentName })).map((item: any) => [item.IndustrySegmentId, item])).values()];
    }
  }

  CheckAll(event: any, Type: String) {
    if (Type == 'ShiftGroup') {
      if (event.target.checked) {
        this.mfilter.ShiftGroupMasterID = this.ShiftGroups.map((e: any) => e.ShiftGroupMasterID);
      } else {
        this.mfilter.ShiftGroupMasterID = [];
      }
    } else if (Type == 'Shift') {
      if (event.target.checked) {
        this.mfilter.ShiftMasterID = this.Shifts.map((e: any) => e.ShiftMasterID);
      } else {
        this.mfilter.ShiftMasterID = [];
      }
    }
    else if (Type == 'Region') {
      if (event.target.checked) {
        this.mfilter.RegionMasterID = this.Regions.map((e: any) => e.RegionMasterID);
      } else {
        this.mfilter.RegionMasterID = [];
      }
    } else if (Type == 'Branch') {
      if (event.target.checked) {
        this.mfilter.BranchMasterID = this.Branchs.map((e: any) => e.BranchMasterID);
      } else {
        this.mfilter.BranchMasterID = [];
      }
    } else if (Type == 'Client') {
      if (event.target.checked) {
        this.mfilter.ClientGroupMasterID = this.Clients.map((e: any) => e.ClientGroupMasterID);
      } else {
        this.mfilter.ClientGroupMasterID = [];
      }
    } else if (Type == 'Site') {
      if (event.target.checked) {
        this.mfilter.SiteMasterID = this.Sites.map((e: any) => e.SiteMasterID);
      } else {
        this.mfilter.SiteMasterID = [];
      }
    } else if (Type == 'SiteOwner') {
      if (event.target.checked) {
        this.mfilter.SiteOwnerID = this.SiteOwners.map((e: any) => e.SiteOwnerID);
      } else {
        this.mfilter.SiteOwnerID = [];
      }
    } else if (Type == 'IndustrySegment') {
      if (event.target.checked) {
        this.mfilter.IndustrySegmentId = this.IndustrySegments.map((e: any) => e.IndustrySegmentId);
      } else {
        this.mfilter.IndustrySegmentId = [];
      }
    }
  }

  formatDeviceInfo(deviceInfo: string): string {
    if (!deviceInfo || deviceInfo.trim() === '') {
      return '';
    }

    const devices = deviceInfo.split(',');
    let deviceListHtml = '<div class="device-list" style="margin-top: 4px; font-size: 12px;">';

    devices.forEach((device, index) => {
      const parts = device.split('-');
      if (parts.length === 2) {
        const deviceSerial = parts[0].trim();
        const status = parts[1].trim();
        const styles = status === '0' ? "background-color: #28a745; box-shadow: 0 0 3px rgba(40, 167, 69, 0.5);" : "background-color: #dc3545; box-shadow: 0 0 3px rgba(220, 53, 69, 0.5);";


        deviceListHtml += `
        <div class="device-item cursor-pointer" style="display: flex; align-items: center; margin-bottom: 2px;"
                data-action="device-click" data-device-serial="${deviceSerial}">
          <span class="device-serial" style="flex: 1;">${deviceSerial}</span>
          <span class="device-status"
              style="width: 10px; height: 10px; border-radius: 50%; display: inline-block;${styles}">
          </span>
        </div>
      `;
      }
    });

    deviceListHtml += '</div>';
    return deviceListHtml;
  }

  GotoDevice(serial: string) {
    if (this.allowRedirectDevice) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to redirect on device page?';
      modalRef.componentInstance.Button1 = 'Yes';
      modalRef.result.then(result => {
        if (result) {
          this.router.navigate([]).then(result => { window.open(`attendancedevice/device/deviceattendance/${serial}`, '_blank'); });
        }
      });
    }
  }

  AllowRedirectOnDeivce() {
    this.userright.ESS_ProfileMenuRightsView({ SelectType: 'GetRights', ESS_MenuMasterId: 342 }).subscribe({
      next: (response) => {
        if (response.Table && response.Table.length > 0) {
          this.allowRedirectDevice = true;
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

}